import type { ThemeType } from '@space-lib/styles/themes/types'

import { css } from 'styled-components'

import custom from './variations/custom'
import danger from './variations/danger'
import info from './variations/info'
import primary from './variations/primary'
import secondary from './variations/secondary'
import success from './variations/success'
import tertiary from './variations/tertiary'
import warning from './variations/warning'

const customizeCosmosButtons = ({ colors }: Pick<ThemeType, 'colors'>) => {
  return css`
    .hot-button {
      background-color: transparent !important;
    }

    .hot-button:hover,
    .hot-button:focus,
    .hot-button:active,
    .hot-button.hot-button--active {
      background-color: ${colors.gray200} !important;
    }

    .hot-button:focus:active {
      background-color: var(--gray-300) !important;
    }

    ${primary({ colors })}
    ${secondary({ colors })}
    ${tertiary({ colors })}
    ${custom()}
    ${info()}
    ${success()}
    ${danger()}
    ${warning()}
  `
}

export default customizeCosmosButtons
